import { Color } from "@opendaw/lib-std";
export const DefaultColorScheme = { hue: 197, saturation: 1.0 };
const scheme = { ...DefaultColorScheme };
const neutral = (saturation, lightness) => new Color(scheme.hue, saturation * scheme.saturation, lightness);
export const Colors = {
    white: new Color(0, 0, 100),
    blue: new Color(189, 100, 65),
    green: new Color(150, 77, 69),
    yellow: new Color(60, 100, 84),
    cream: new Color(65, 37, 83),
    orange: new Color(31, 100, 73),
    red: new Color(354, 100, 65),
    purple: new Color(314, 100, 78),
    menuActive: new Color(210, 90, 40),
    get bright() { return neutral(5, 100); },
    get gray() { return neutral(31, 91); },
    get dark() { return neutral(15, 84); },
    get shadow() { return neutral(10, 60); },
    get black() { return neutral(10, 30); },
    get background() { return neutral(8, 9); },
    get panelBackground() { return neutral(14, 12); },
    get panelBackgroundBright() { return neutral(13, 16); },
    get panelBackgroundDark() { return neutral(14, 11); },
    get headerBackground() { return neutral(14, 3); },
    get footerBackground() { return neutral(14, 9); }
};
export const setColorScheme = ({ hue, saturation }) => {
    scheme.hue = hue;
    scheme.saturation = saturation;
};
export const initializeColors = (root) => {
    Object.entries(Colors).forEach(([name, value]) => {
        const cssName = name.replace(/([A-Z])/g, "-$1").toLowerCase();
        root.style.setProperty(`--color-${cssName}`, value.toString());
    });
};
